'use strict';

var _ = require('lodash');
var FaresOptimizerAnalysisFilterConfigurationService = function FaresOptimizerAnalysisFilterConfigurationService(configurationService, faresOptimizerConstants) {
  var isFieldValueArray = [faresOptimizerConstants.AUTO_APPROVAL_STOPPED_KEY];
  function mapToDropdown(item) {
    return {
      value: item,
      dropdownVisibleValue: item
    };
  }
  function mapAttribute(attributeData) {
    return _.chain(attributeData).sort().map(mapToDropdown).value();
  }
  function createGroupFromArrayValues(rawData, category) {
    return _.chain(rawData).map(category).reduce(function (reasonKeys, reasonKey) {
      reasonKeys = _.union(reasonKeys, reasonKey);
      return reasonKeys;
    }, []).values().value();
  }
  function mapAllGroupings(rawData, category) {
    var groups = -1 !== isFieldValueArray.indexOf(category) ? createGroupFromArrayValues(rawData, category) : _.chain(rawData).map(category).uniq().compact().value();
    return _.chain(groups).map(mapToDropdown).value();
  }
  function getMappedComboBox(attributeName, title, attributeData, listItemHeight) {
    return {
      filterId: attributeName,
      title: title,
      type: faresOptimizerConstants.TYPE_COMBOBOX,
      options: attributeData,
      className: title.toLowerCase().replace(/\s+/g, '-'),
      listItemHeight: listItemHeight
    };
  }
  function getFilter(rawData, attributeName, title) {
    var selectedAttribute = _.chain(rawData).map(attributeName).uniq().value();
    var attributeData = mapAttribute(selectedAttribute);
    return getMappedComboBox(attributeName, title, attributeData);
  }
  function getPosFilter(rawData) {
    return getFilter(rawData, 'pos', faresOptimizerConstants.POS);
  }
  function getCarrierFilter(rawData) {
    return getFilter(rawData, 'carrier', faresOptimizerConstants.HOST_CARRIER);
  }
  function getMarketFilter(rawData) {
    return getFilter(rawData, 'market', faresOptimizerConstants.MARKET);
  }
  function getFareTypeFilter(rawData) {
    return getFilter(rawData, 'tripType', faresOptimizerConstants.FARE_TYPE);
  }
  function getOriginFilter(rawData) {
    var selectedOrigins = _.chain(rawData).map(function (item) {
      return item.market.split('-')[0];
    }).uniq().value();
    var origins = mapAttribute(selectedOrigins);
    return getMappedComboBox('origin', faresOptimizerConstants.ORIGIN, origins);
  }
  function getDestFilter(rawData) {
    var selectedDestinations = _.chain(rawData).map(function (item) {
      return item.market.split('-')[1];
    }).uniq().value();
    var destinations = mapAttribute(selectedDestinations);
    return getMappedComboBox('destination', faresOptimizerConstants.DESTINATION, destinations);
  }
  function getCabinFilter(rawData) {
    return getFilter(rawData, 'cabin', faresOptimizerConstants.CABIN);
  }
  function getDisableStatus(selectedStatuses, item) {
    return _.includes(selectedStatuses, item) !== true;
  }
  function getStatusFilter(rawData) {
    var selectedStatuses = _.chain(rawData).map('status').uniq().value();
    var statuses = configurationService.getFoRecommendationLadderStatuses();
    return {
      filterId: 'status',
      title: faresOptimizerConstants.STATUS,
      type: faresOptimizerConstants.TYPE_CHECKBOX,
      options: _.map(statuses, function (item) {
        return {
          value: item,
          label: item,
          disableStatus: getDisableStatus(selectedStatuses, item)
        };
      })
    };
  }
  function getActionCodeFilter(rawData) {
    var selectedActionCodes = _.chain(rawData).flatMap('recommendationActionCodes').uniq().value();
    var actionCodes = ['X', 'C', 'N'];
    return {
      filterId: 'recommendationActionCodes',
      title: faresOptimizerConstants.ACTION_CODE,
      type: faresOptimizerConstants.TYPE_CHECKBOX,
      options: _.map(actionCodes, function (item) {
        return {
          value: item,
          label: getLabelForActionCodes(item),
          disableStatus: getDisableStatus(selectedActionCodes, item)
        };
      })
    };
  }
  function getMinStaysListFilter(rawData) {
    var minStaysList = _.chain(rawData).flatMap('minStaysList').uniq().value();
    return getMappedComboBox('minStaysList', 'Min Stay', mapAttribute(minStaysList));
  }
  function getMaxStayListFilter(rawData) {
    var maxStayList = _.chain(rawData).flatMap('maxStayList').uniq().value();
    return getMappedComboBox('maxStayList', 'Max Stay', mapAttribute(maxStayList));
  }
  function getLabelForActionCodes(code) {
    if (code === 'C') {
      return 'Change';
    }
    if (code === 'N') {
      return 'New';
    }
    if (code === 'X') {
      return 'Cancel';
    }
  }
  function sortMarketTierFilter(selectedMarketTiers) {
    if (selectedMarketTiers.indexOf(faresOptimizerConstants.NOT_ASSIGNED) > -1) {
      var marketTiers = _.pull(selectedMarketTiers, faresOptimizerConstants.NOT_ASSIGNED);
      return _.chain(marketTiers).sort(function (a, b) {
        return parseInt(a) - parseInt(b);
      }).concat(faresOptimizerConstants.NOT_ASSIGNED).value();
    }
    return selectedMarketTiers.sort(function (a, b) {
      return parseInt(a) - parseInt(b);
    });
  }
  function getMarketTierFilter(rawData) {
    var selectedMarketTiers = _.chain(rawData).map('marketTier').uniq().filter().value();
    if (_.isEmpty(selectedMarketTiers)) {
      return [];
    }
    selectedMarketTiers = sortMarketTierFilter(selectedMarketTiers);
    return {
      filterId: 'marketTier',
      title: faresOptimizerConstants.MARKET_TIER,
      type: faresOptimizerConstants.TYPE_CHECKBOX,
      options: _.map(selectedMarketTiers, function (item) {
        return {
          value: item,
          label: item
        };
      })
    };
  }
  function getGroupFilter(rawData, attributeName, title, listItemHeight) {
    var groups = mapAllGroupings(rawData, attributeName);
    return getMappedComboBox(attributeName, title, groups, listItemHeight);
  }
  function getAdvPurchaseGroupFilter(rawData) {
    return getGroupFilter(rawData, 'apGroup', faresOptimizerConstants.ADVANCE_PURCHASE_GROUP);
  }
  function getAutoApprovalStoppedReasons(rawData) {
    return getGroupFilter(rawData, 'autoApprovalStoppedReasonsFilterKeys', faresOptimizerConstants.AUTO_APPROVAL_STOPPED, 40);
  }
  function loadFiltersFromConfig(rawData) {
    return _.concat([], getCarrierFilter(rawData), getMarketFilter(rawData), getOriginFilter(rawData), getDestFilter(rawData), getCabinFilter(rawData), getPosFilter(rawData), getFareTypeFilter(rawData), getMarketTierFilter(rawData), getStatusFilter(rawData), getActionCodeFilter(rawData), getAdvPurchaseGroupFilter(rawData), getMinStaysListFilter(rawData), getMaxStayListFilter(rawData), getAutoApprovalStoppedReasons(rawData));
  }
  return {
    loadFiltersFromConfig: loadFiltersFromConfig,
    getStatusFilter: getStatusFilter
  };
};
FaresOptimizerAnalysisFilterConfigurationService.$inject = ['ConfigurationService', 'FaresOptimizerConstants'];
module.exports = FaresOptimizerAnalysisFilterConfigurationService;